import { getDirectusImg } from 'services/graphql/directus';
import { Author } from 'types';

interface Props {
  author: Author;
  totalCountPostsByUserID: number;
}

export default function PostAuthor({ author, totalCountPostsByUserID }: Props) {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  const { avatar, first_name, last_name } = author;

  return (
    <div className="max-w-[1120px] border border-gray-500 rounded py-4 px-5">
      <div className="flex flex-col md:flex-row items-center justify-center md:justify-between mb-2 gap-2">
        <div className="flex flex-col md:flex-row items-center">
          <div className="mb-2 md:mb-0">
            <img
              src={avatar ? getDirectusImg(avatar) : '/svg/anonymous.svg'}
              alt="Author"
              height={40}
              width={40}
              style={{ borderRadius: '50%' }}
            />
          </div>

          <div className="flex items-center">
            <p className="text-base text-gray-100 font-medium mx-2">Tác giả:</p>
            <p className="text-base font-medium text-gray-300">
              {last_name} {first_name}
            </p>
          </div>
        </div>
        <p className="text-sm text-gray-100">
          Đã đóng góp: {totalCountPostsByUserID} bài viết
        </p>
      </div>
    </div>
  );
}
